import { api as generatedApi } from 'gen/rtk-openapi'
// import normalize from 'utils/normalize'

const TAG_TYPES = {
  commodities: 'Commodities',
  priceSheets: 'PriceSheets',
  priceEntries: 'PriceEntries',
  materialTypes: 'MaterialTypes',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.commodities],
  endpoints: {
    getCommodities: {
      providesTags: result =>
        result && result.Items
          ? // successful query
            [
              ...result.Items.map(commodity => ({
                type: TAG_TYPES.commodities,
                id: commodity.id,
              })),
              { type: TAG_TYPES.commodities, id: 'LIST' },
            ]
          : // error occurred, refetch when `{ type: 'Commodities', id: 'LIST' }` is invalidated
            [{ type: TAG_TYPES.commodities, id: 'LIST' }],
    },
    createCommodity: {
      invalidatesTags: () => [{ type: TAG_TYPES.commodities }],
    },
    getCsv: {},
    postCsv: {
      invalidatesTags: () => [{ type: TAG_TYPES.priceSheets }, { type: TAG_TYPES.priceEntries }],
    },

    getPriceSheetCsv2: {},
    getPriceSheetCsvMulti: {},
    putPriceSheetCsv2: {
      invalidatesTags: () => [{ type: TAG_TYPES.priceSheets }, { type: TAG_TYPES.priceEntries }],
    },
    putPriceSheetCsvMulti: {
      invalidatesTags: () => [{ type: TAG_TYPES.priceSheets }, { type: TAG_TYPES.priceEntries }],
    },
    getCommodity: {
      providesTags: (result, error, { commodityId }) => [{ type: TAG_TYPES.commodities, id: commodityId }],
    },
    putCommodity: {
      invalidatesTags: (result, error, { commodityId }) => [
        { type: TAG_TYPES.commodities },
        { type: TAG_TYPES.commodities, id: 'LIST' },
        { type: TAG_TYPES.materialTypes },
        { type: TAG_TYPES.commodities, id: commodityId },
      ],
    },
  },
})
export const useGetCsvLazyQuery = api.endpoints.getCsv.useLazyQuery
export const useGetPriceSheetCsvLazyQuery = api.endpoints.getPriceSheetCsv2.useLazyQuery
export const useGetPriceSheetCsvMultiLazyQuery = api.endpoints.getPriceSheetCsvMulti.useLazyQuery
export const useGetCommoditiesLazyQuery = api.endpoints.getCommodities.useLazyQuery

export const {
  useGetCommoditiesQuery,
  useCreateCommodityMutation,
  usePostCsvMutation,
  usePutPriceSheetCsv2Mutation,
  usePutPriceSheetCsvMultiMutation,
  useGetCommodityQuery,
  usePutCommodityMutation,
} = api
